




















import { defineComponent, PropType, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<any[]>,
      default: () => {
        return []
      },
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      },
      // required: true,
    },
    filter: {
      type: Object,
      default: () => {
        return {}
      },
      // required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['paginationOnChange'],
  setup(props, { emit }) {
    const itemsData = computed(() => props.items)
    const filterData = computed(() => props.filter)
    const paginationData = computed(() => props.pagination)

    const paginationOnChange = () => {
      emit('paginationOnChange', filterData.value)
    }

    return { itemsData, filterData, paginationData, paginationOnChange }
  },
})
